export default {
  userId: null,
  email: null,
  name: null,
  phone: null,
  memberType: null,
  logged: false,
};
